// extracted by mini-css-extract-plugin
export var fileUpload = "_dy-1";
export var modalButton = "_dy-0";